<template>
  <div id="sac-page-not-found">
    <img
      src="@shared/assets/img/general/chill.svg"
      class="chill-img"
    >
    <div class="sac-fixed-container">
      <div class="sac__font-50 bold">
        {{ title }}
      </div>
      <div class="sac__font-24 margin-top-4">
        {{ body }}
      </div>
      <button
        class="home-btn"
        @click="goToHomePage"
      >
        Back To Home
      </button>
      <div>
        <img
          src="@shared/assets/img/logo/black-logo.png"
          alt="SmartAC.com"
          class="sac-logo"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SACPageNotFound',
  data() {
    return {
      title: 'Page Not Found',
      body: 'It looks like you\'ve reached this page in error',
    };
  },
  methods: {
    goToHomePage() {
      this.$router.push('/service');
    },
  },
  mounted() {
    if (localStorage.getItem('maintenanceMode')) {
      const {
        Title,
        Message,
      } = JSON.parse(localStorage.getItem('maintenanceMode'));
      this.title = Title;
      this.body = Message;
    }
  },
};
</script>

<style lang="scss" scoped>

#sac-page-not-found {
  display: grid;
  overflow: hidden;
  position: relative;
  background-color: $NBLUE10;

  .chill-img {
    height: 100vh;
    width: 100%;
  }

  .sac-fixed-container {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 80px 360px;
    div {
      line-height: 1.3;
    }
    .home-btn {
      padding: 10px 20px;
      background-color: $NBLUE100;
      color: $WHITE;
      border-radius: 8px;
      font-weight: 600;
      margin-top: 24px;
    }

    .sac-logo {
      width: 184px;
      height: 21px;
      margin-top: 24px;
    }
  }
}
</style>
